import axios from 'axios'
import { BASEURL } from './api.variables'
import { getCookie } from '../helpers'
import { CreateUrlWithParams } from './helpers'

const BASEPLACESURL = `${BASEURL}/places`
const GETPLACESURL = (limit, skip, language) => `${BASEURL}/admin/places?limit=${limit}&skip=${skip}&language=${language}`
const GETPLACEURL = (placeId) => `${BASEPLACESURL}/${placeId}`
const GETPLACELANGUAGEURL = (placeId) => `${BASEPLACESURL}/${placeId}/languages`
const UPDATELACELANGUAGEURL = (placeId, id) => `${BASEPLACESURL}/${placeId}/languages/${id}`
const GETPLACECHECKINQRCODE = (placeId) => `${BASEURL}/admin/places/${placeId}/checkinqrcode`
const GETPLACERATINGQRCODE = (placeId) => `${BASEURL}/admin/places/${placeId}/ratingqrcode`

const headers = () => {
  return {
    Authorization: document.redecienciaToken ? `Bearer ${document.redecienciaToken}` : `Bearer ${getCookie('redecienciaToken')}`
  }
}

const GetPlaces = (limit = 50, skip = 0, language = 'pt') => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: GETPLACESURL(limit, skip, language),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const CreatePlace = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      data,
      url: BASEPLACESURL,
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const CreatePlaceTranslation = (data, placeId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      data,
      url: GETPLACELANGUAGEURL(placeId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const UpdatePlaceTranslation = (data, placeId, id) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'patch',
      data,
      url: UPDATELACELANGUAGEURL(placeId, id),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const DeletePlaceTranslation = (placeId, id) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      url: UPDATELACELANGUAGEURL(placeId, id),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const UpdatePlace = (data, placeId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'patch',
      data,
      url: GETPLACEURL(placeId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const GetPlace = (placeId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: GETPLACEURL(placeId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const GetPlaceCheckinQrCode = (placeId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: GETPLACECHECKINQRCODE(placeId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const GetPlaceRatingQrCode = (placeId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: GETPLACERATINGQRCODE(placeId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const GetPlaceLanguage = (placeId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: GETPLACELANGUAGEURL(placeId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const GetPlaceRatings = async ({ id, params }) => {
  try {
    return await axios({
      method: 'get',
      url: CreateUrlWithParams(`${BASEPLACESURL}/${id}/ratings`, { ...params }),
      headers: headers()
    })
  } catch (error) {
    throw error
  }
}

const DeletePlaceRating = async ({ placeId, id }) => {
  try {
    return await axios({
      method: 'delete',
      url: `${BASEPLACESURL}/${placeId}/ratings/${id}`,
      headers: headers()
    })
  } catch (error) {
    throw error
  }
}

const AddModeratorToPlace = async ({ placeId, data }) => {
  try {
    return await axios({
      method: 'post',
      url: `${BASEPLACESURL}/${placeId}/moderators`,
      headers: headers(),
      data
    })
  } catch (error) {
    throw error
  }
}

const RemovePlaceModerator = async ({ placeId, id }) => {
  try {
    return await axios({
      method: 'delete',
      url: `${BASEPLACESURL}/${placeId}/moderators/${id}`,
      headers: headers()
    })
  } catch (error) {
    throw error
  }
}

const GetPlaceContributions = async ({ placeId, params }) => {
  try {
    return await axios({
      method: 'get',
      url: CreateUrlWithParams(`${BASEURL}/admin/places/${placeId}/images/contributions`, { ...params }),
      headers: headers()
    })
  } catch (error) {
    throw error
  }
}

const DeletePlaceContributions = async ({ placeId, id }) => {
  try {
    return await axios({
      method: 'delete',
      url: `${BASEURL}/places/${placeId}/images/${id}`,
      headers: headers()
    })
  } catch (error) {
    throw error
  }
}

export {
  GetPlaces,
  CreatePlace,
  GetPlace,
  UpdatePlace,
  GetPlaceLanguage,
  UpdatePlaceTranslation,
  CreatePlaceTranslation,
  DeletePlaceTranslation,
  GetPlaceCheckinQrCode,
  GetPlaceRatingQrCode,
  GetPlaceRatings,
  DeletePlaceRating,
  AddModeratorToPlace,
  RemovePlaceModerator,
  GetPlaceContributions,
  DeletePlaceContributions
}



// WEBPACK FOOTER //
// ./src/api/place.js